export const maxDictionaryQueryLength = 200;

export type Type = 'PDF' | 'EPUB' | 'PLAYER' | 'IMAGE' | 'UNKNOWN';

// Lightweight version without ReactPlayer dependency
export const getType = (url: string): Type =>
  /\.epub/.test(url)
    ? 'EPUB'
    : /\.pdf/.test(url)
    ? 'PDF'
    : /\.(gif|jpg|jpeg|png|tiff|svg)/.test(url)
    ? 'IMAGE'
    : /\.(mp4|webm|ogg|mp3|wav|avi|mov|wmv|flv|mkv)/.test(url)
    ? 'PLAYER'
    : 'UNKNOWN';

// Lightweight text normalization utility
const whitelistPattern = /[A-Za-z0-9\s-]+/g;
export const normaliseText = (query: string): string | undefined => {
  const matches = query.match(whitelistPattern);
  if (!matches) {
    return undefined;
  }
  const result = matches.join('').trim();
  return result.length > 0 ? result : undefined;
};

// Re-export URL utilities from common (consolidated to avoid duplication)
export { getReaderExternalUrl, getDirectNativeAppUrl } from '@readcloud/common/lib/externalUrl';

export const isPublisherOfBook = (
  book?: { publisher?: string },
  scopeParams?: { U_Publisher_Author?: { publishers?: string[] } }
) => {
  const userPublishers = scopeParams?.U_Publisher_Author?.publishers;
  const bookPublisher = book?.publisher;
  const isPublisher =
    userPublishers &&
    bookPublisher &&
    userPublishers?.indexOf(bookPublisher) !== -1;
  return !!isPublisher;
};

export const canEditAnnotation = (user: any, annotation: any) => {
  if (!annotation || !user || !user.id) {
    return false;
  }
  return annotation.author === user.id || user.role === 'Teacher';
};

// Lightweight page label utility
export const makePageLabelsByLocation = (pageLabels: any[]) =>
  pageLabels.reduce(
    (acc, pageLabel) => ({ ...acc, [pageLabel.value]: pageLabel }),
    {}
  );

// Lightweight math utilities
export const round = (num: number) => parseFloat(num.toFixed(4));

export const getAsr = (viewport: { height: number; width: number }) =>
  round(viewport.width / viewport.height);

// Constants
export const MAX_SQUARE_VIEWPORT_LENGTH = 2800;
